import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useSelectedProject } from "Hooks";
import { useState } from "react";
import { useCSVUploaderContext } from "Providers/CSVUploaderProvider";
import { createMedia } from "features/media";
import { ApiMediaType } from "@incendium/api";
import { UploaderButton } from "features/media";
import { motion, easeOut } from "motion/react";
import { S3Response } from "features/media/types";

function UploadStepOne() {
  const theme = useTheme();
  const {  selectedProject } = useSelectedProject();
  const [uploading, setUploading] = useState(false);
  const { step, setStep, setMedia } = useCSVUploaderContext();

  const onProgress = (percent: number, status: string, file: File) => {
    setUploading(percent < 100);
  };

  // todo: hanlde error ui
  const onError = (error: string) => {
    console.error(error);
    setUploading(false);
  };

  const onFinish = async (result: S3Response, file: File) => {
    // add as media
    const res = await createMedia(
      result,
      file,
      selectedProject?.id as number,
      ApiMediaType.CSV
    );

    setMedia(res || {});
    setStep(step + 1);
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.3,
        ease: easeOut
      }
    }
  };

  const titleVariants = {
    hidden: {
      opacity: 0,
      y: -30,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: easeOut
      }
    }
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      pb={20}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        style={{ width: "100%" }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          maxWidth={350}
          mx="auto"
        >
          <Stack spacing={3}>
            <motion.div variants={titleVariants}>
              <Typography
                variant="h1"
                align="center"
                mb={2}
                sx={{
                  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.vibrant})`,
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: 600
                }}
              >
                Upload CSV to Get Started.
              </Typography>
            </motion.div>

            <Box
              component={motion.div}

              sx={{ width: 500 }}
            >

              <UploaderButton
                type={ApiMediaType.CSV}
                uploading={uploading}
                text="Upload CSV"
                onFinish={onFinish}
                onError={onError}
                hidden={true}
                path={`csv`}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                project={selectedProject || {}}
                onProgress={onProgress}
                useDropZone={true}
                dropZoneText="Drag and drop your CSV file here or click to browse"
                buttonProps={{
                  size: "large",
                  fullWidth: true
                }}
              />

            </Box>
          </Stack>
        </Box>
      </motion.div>
    </Box>
  );
}

export default UploadStepOne;
